/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Space, Form } from "antd";
import MarkpageModel from "./MarkpageModel";
import { useSelector, useDispatch } from "react-redux";
import {
  selectRate,
  isSliMutliService,
  resetCurrentFeedbackScore,
  nextPage,
  fetchSendCollectedFeedback,
} from "Redux/actions";
import { find, isEmpty, pick } from "lodash";
import ComponentTitle from "./components/ComponentTitle";
import ServiceRow from "./components/sli/ServiceRow";
import SingleService from "./components/sli/SingleService";
import { orderByPosition } from "utils/helperFunctions";
import Markpage from "./Markpage";

const SliModel = ({ data, form }) => {
  const [isSingle, setisSingle] = useState(false);
  const [final, setFinal] = useState(false);
  const {
    serviceIds,
    rateParam,
    selectedLanguage,
    markpage,
    pages,
    currentPage,
    widgetJSON: { data: widgetJSONData },
    isFinal,
    pageComponents,
  } = useSelector((state) => state);

  const { error_messages: errorMessages } = widgetJSONData?.general_settings || {};
  const [components, setComponents] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    setFinal(isFinal);
  }, [isFinal]);

  useEffect(() => {
    try {
      serviceIds.map((serviceId, index) => {
        if (index === 0) {
          const service = find(data.attrs.service, ["id", serviceId]);
          if (rateParam && service) {
            const rate = find(service.rate_options, [
              "name",
              generateRateByParam(rateParam),
            ]);
            console.log(rate);
            dispatch(
              selectRate({
                serviceId: service.id,
                option: rate,
              })
            );
            // dispatch(nextPage());
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
    dispatch(resetCurrentFeedbackScore());
  }, []);

  useEffect(() => {
    if (data.attrs.service.length > 1) {
      dispatch(isSliMutliService(true));
    } else {
      dispatch(isSliMutliService(false));
    }
    const components = pick(pages[currentPage], [
      "comment_data",
      "customer_data",
      "custom_field_feedback_component",
    ]);
    setComponents(components);
  }, [currentPage]);

  useEffect(() => {
    if (pageComponents) {
      if (
        pageComponents.length === 1 &&
        pageComponents[0].attrs?.service?.length === 1
      ) {
        setisSingle(true);
      } else if (isSingle) {
        setisSingle(false);
      }
    }
  }, [pageComponents]);

  const generateRateByParam = (param) => {
    const rates = {
      ex: "excellent",
      gd: "good",
      nt: "neutral",
      bd: "bad",
      vb: "unacceptable",
    };

    return rates[param] || "";
  };

  const onFeedbackMade = (service, option) => () => {
    // console.log(service, option);
    form.setFieldsValue({
      [service.id]: option.name,
    });
    dispatch(
      selectRate({
        serviceId: service.id,
        option,
      })
    );

    // if (isFinal && isSingle && !option?.markpage_id) {
    //   dispatch(fetchSendCollectedFeedback());
    // }
    if (isSingle && !option?.markpage_id) {
      sendFeedBack(option);
    }
  };

   const sendFeedBack = (option) => {
     setTimeout(() => {
       setFinal((prev) => {
         if (prev) {
           dispatch(fetchSendCollectedFeedback());
         }
         return prev;
       });
     }, 300);
   };

  return (
    <>
      {/* <MarkpageModel open={markpage.show} handleClose={closeMarkpage} /> */}
      <Markpage />
      <ComponentTitle component={data} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Space
          direction="vertical"
          // size={10}
          // style={{ paddingLeft: "20px", paddingRight: "20px" }}
          className="gap padding"
        >
          {orderByPosition(data.attrs.service).map((service, index) => {
            const isSingle =
              data.attrs.service.length < 2 && isEmpty(components);
            const { required = false } = service;
            return isSingle ? (
              // <Form.Item
              //   name={service.id}
              //   className="reset-ant-form"
              //   rules={[
              //     {
              //       required: required,
              //       message: errorMessages.required[selectedLanguage],
              //     },
              //   ]}
              // >
              //   <Row align="center" justify="space-around">
              //     {service.rate_options.map((option, index) => (
              //       <SingleService
              //         key={index}
              //         service={service}
              //         option={option}
              //         data={data}
              //         onFeedbackMade={onFeedbackMade}
              //         selectedLanguage={selectedLanguage}
              //       />
              //     ))}
              //   </Row>
              // </Form.Item>
              <ServiceRow
                service={service}
                data={data}
                selectedLanguage={selectedLanguage}
                onSmileClick={onFeedbackMade}
                key={index}
              />
            ) : (
              <ServiceRow
                service={service}
                data={data}
                selectedLanguage={selectedLanguage}
                onSmileClick={onFeedbackMade}
                key={index}
              />
            );
          })}
        </Space>
      </div>
    </>
  );
};

export default SliModel;
